import { encryptStorage } from 'src/Util'
import { documentsAPI, licensingAPI, usersAPI } from '../api'
import axios from 'axios'
//import XLSX from 'xlsx';
//Action Types
export const DASHBOARD_FILE_WIDGET = 'DASHBOARD_FILE_WIDGET'
export const DASHBOARD_EDITOR_LIST = 'DASHBOARD_EDITOR_LIST'
export const DASHBOARD_DOCUMENT_STATUS = 'DASHBOARD_DOCUMENT_STATUS'
export const SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA'
export const DOWNLOAD_DASHBOARD_DATA = 'DOWNLOAD_DASHBOARD_DATA'
export const EMAIL_DASHBOARD_DATA = 'EMAIL_DASHBOARD_DATA'
export const LICENSE_DASHBOARD_DATA = 'LICENSE_DASHBOARD_DATA'
export const SEARCH_COMPANY_DATA = 'SEARCH_COMPANY_DATA'
export const CREATE_COMPANY = 'CREATE_COMPANY'
export const GET_COUNTRIES = 'GET_COUNTRIES'
export const UPDATE_COMPANY = 'UPDATE_COMPANY'
export const CLEAR_COMPANY_STATUS = 'CLEAR_COMPANY_STATUS'
export const GET_SUBSCRIPTION_DEFAULTS = 'GET_SUBSCRIPTION_DEFAULTS'

//Action Creators
export const fileCountForDashboard = () => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  const data = {
    user_id: `${userDetail.user_id}`,
    company_id: `${userDetail.company_id}`,
  }
  documentsAPI.post('/document/dashboard/document-widget', data).then((widgetResponse) => {
   // if (widgetResponse.data.status === 'success') encryptStorage.setItem('session-auth', true)
    dispatch({
      type: DASHBOARD_FILE_WIDGET,
      payload: widgetResponse.data,
    })
  })
}

export const editorListForDashboard = () => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  const data = {
      "endDateFrom": "",
      "endDateTo": "",
      "filterStatusValue":["accessibilityReview in progress","accessibilityReview completed."],
      "filterTagValue": [],
      "limit": 5,
      "offset": 0,
      "searchTerm": "",
      "sortBy": "",
      "sortOrder": "",
      "stage": "ALL",
      "startDateFrom": "",
      "startDateTo": "",
      "userId": `${userDetail.user_id}`
  }
  documentsAPI
    .post('/document/files-search', data)
    .then((widgetResponse) => {
      //
      //if (widgetResponse.data.status === 'success') encryptStorage.setItem('session-auth', true)
      dispatch({
        type: DASHBOARD_EDITOR_LIST,
        payload: widgetResponse.data,
      })
    })
}

export const documentStatusForDashboard = () => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  const data = {
    user_id: `${userDetail.user_id}`,
    company_id: `${userDetail.company_id}`,
  }
  documentsAPI.post('/document/dashboard/document-status-widget', data).then((widgetResponse) => {
    //if (widgetResponse.data.status === 'success') encryptStorage.setItem('session-auth', true)
    dispatch({
      type: DASHBOARD_DOCUMENT_STATUS,
      payload: widgetResponse.data,
    })
  })
}

export const getDashboardData = (dashboardDataObj) => (dispatch) => {
  console.log('Dashboard object',dashboardDataObj);
  //debugger;
  documentsAPI
    .post(`document/admin/dashboard/`, {
      companyName: dashboardDataObj.companyName,
      from:dashboardDataObj.from,
      to:dashboardDataObj.to,
      offset: dashboardDataObj.offset,
      limit: 10,
      page:dashboardDataObj.page +1,
      
      firstName: dashboardDataObj.firstName,
      lastName: dashboardDataObj.lastName,
      companyNameFilter: dashboardDataObj.companyNameFilter,
      lastLogin: dashboardDataObj.lastLogin,
      sortField: dashboardDataObj.sortField,
      sortOrder: dashboardDataObj.sortOrder
    })
    .then((response) => {
      console.log('Actions Admin Dashboard -> Response', response)
      dispatch({
        type: SET_DASHBOARD_DATA,
        payload: response.data
      })
    })


  
}

export  const downloadDashboardData =  (downloadDataObj) => async (dispatch) => {
  console.log('download dashboard data action call')
  var redirectUriPrefix = window.location.origin;
  console.log(redirectUriPrefix)
 if(redirectUriPrefix.includes('localhost')){
   redirectUriPrefix = 'https://accessibilitydev.codemantra.com'
 }
  var downloadurlWithParams;
  var downloadurlWithParamsNoPrefix;
  var downloadurl = `${redirectUriPrefix}/api/document/document/admin/dashboard/download?`;
    downloadurlWithParams = downloadurl;
    if(downloadDataObj.companyName != '' && downloadDataObj.companyName!=undefined){
      downloadurlWithParams = downloadurl +`companyName=${downloadDataObj.companyName}&`;
      downloadurlWithParamsNoPrefix = `companyName=${downloadDataObj.companyName}&`;
    }
    if(downloadDataObj.from!= '' && downloadDataObj.from!=undefined){
      downloadurlWithParams = downloadurlWithParams +`from=${downloadDataObj.from}&`;
      downloadurlWithParamsNoPrefix = downloadurlWithParamsNoPrefix + `from=${downloadDataObj.from}&`;
    }
    if(downloadDataObj.to!= ''&& downloadDataObj.to!=undefined){
      downloadurlWithParams = downloadurlWithParams +`to=${downloadDataObj.to}&`;
      downloadurlWithParamsNoPrefix =  downloadurlWithParamsNoPrefix +`to=${downloadDataObj.to}&`;
    }
    
  documentsAPI
 // .get(`document/admin/dashboard/download?companyName=${downloadDataObj.companyName}&from=${downloadDataObj.from}&to=${downloadDataObj.to}`)
 .get(`document/admin/dashboard/download?`+downloadurlWithParamsNoPrefix)
  .then((response) => {
    
    console.log('Response from download api:',response);
    if(response.status == 200){
     var redirectUriPrefix = window.location.origin;
     console.log(redirectUriPrefix)
    if(redirectUriPrefix.includes('localhost')){
      redirectUriPrefix = 'https://accessibilitydev.codemantra.com'
    }
    
     
    var downloadurl = `${redirectUriPrefix}/api/document/document/admin/dashboard/download?`;
    downloadurlWithParams = downloadurl;
    if(downloadDataObj.companyName != '' && downloadDataObj.companyName!=undefined){
      downloadurlWithParams = downloadurl +`companyName=${downloadDataObj.companyName}&`;
    }
    if(downloadDataObj.from!= '' && downloadDataObj.from!=undefined){
      downloadurlWithParams = downloadurlWithParams +`from=${downloadDataObj.from}&`;
    }
    if(downloadDataObj.to!= ''&& downloadDataObj.to!=undefined){
      downloadurlWithParams = downloadurlWithParams +`to=${downloadDataObj.to}&`;
    }
    console.log('The constructed URL is',downloadurlWithParams);
    window.open(downloadurlWithParams, '_blank');
    window.close();
    //newAuthWindow.open(https://accessibilitydev.codemantra.com/api/document/document/admin/dashboard/download?companyName=salesforce&from=2022-05-01&to=2023-05-10', '_blank')
    //newAuthWindow.close();
    var responseDispatched;
    
      responseDispatched = response.data;
    }
    else if(downloadDataObj == 'reset'){
      responseDispatched = null;
    }
    else{
      responseDispatched ='Error case'
    }

    
    dispatch({
      type: DOWNLOAD_DASHBOARD_DATA,
      payload: responseDispatched
    })
  })
  .catch((error) => {
    var errResponseDispatched = 'Error case';
   console.log('Error message:',error);
   dispatch({
    type: DOWNLOAD_DASHBOARD_DATA,
    payload: errResponseDispatched
  })
  })
  console.log('Download URL:',downloadurlWithParams);
  await axios({
    url: downloadurlWithParams,
    method: "GET",
    responseType: "blob", // important
    onDownloadProgress: (progressEvent) => {
     
        let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        console.log('percentCompleted',percentCompleted);
         // you can use this to show user percentage of file downloaded
    }
})
  
  
 /*  documentsAPI
    .post(`document/admin/dashboard/download/`, {
      companyName: downloadDataObj.companyName,
      from:downloadDataObj.from,
      to:downloadDataObj.to,
      offset: downloadDataObj.page*10,
      limit: 10,
      page:downloadDataObj.page +1
    })
    .then((response) => {
      console.log('Response value', response);
      if (response.status == 200) {
        const byteStream = response.data;
        const fileName = "example.xlsx";
       // downloadExcelFromByteStream(byteStream, fileName);

      /*  const blob = new Blob([response.data], { type: "application/octet-stream" });
       const url = URL.createObjectURL(blob);
       window.open(url); */
    //  createAndDownloadBlobFile(response.data,'testName',)
   /*  var bytes = new Uint8Array(response.data); // pass your byte response to this constructor

    var blob=new Blob([bytes], {type: "application/octet-stream"});// change resultByte to bytes

      var link=document.createElement('a');
      link.href=window.URL.createObjectURL(blob);
      link.download="myFileName.xlsx";
      link.click(); */
       
       // window.open(response.data, '_blank')
      // var sampleArr = base64ToArrayBuffer(response.data);
       //Download(response.data,"application/octet-stream")
      // const arrayBuffer = base64ToArrayBufferModified(response.data);
        //createAndDownloadBlobFile(arrayBuffer, 'testName');
       // saveByteArray("Sample Report.xlsx", sampleArr);
       
    //   } else {
    //     console.log('view report not available')
    //   }
    //   console.log('Actions Admin Dashboard -> Response', response)
      
    // }) 


  
}

export const setDownloadDataFlag = (downloadDataObj) => (dispatch) => {
  console.log('download dashboard data action call')
    dispatch({
      type: DOWNLOAD_DASHBOARD_DATA,
      payload: null
    })
  }
  
  
 /*  documentsAPI
    .post(`document/admin/dashboard/download/`, {
      companyName: downloadDataObj.companyName,
      from:downloadDataObj.from,
      to:downloadDataObj.to,
      offset: downloadDataObj.page*10,
      limit: 10,
      page:downloadDataObj.page +1
    })
    .then((response) => {
      console.log('Response value', response);
      if (response.status == 200) {
        const byteStream = response.data;
        const fileName = "example.xlsx";
       // downloadExcelFromByteStream(byteStream, fileName);

      /*  const blob = new Blob([response.data], { type: "application/octet-stream" });
       const url = URL.createObjectURL(blob);
       window.open(url); */
    //  createAndDownloadBlobFile(response.data,'testName',)
   /*  var bytes = new Uint8Array(response.data); // pass your byte response to this constructor

    var blob=new Blob([bytes], {type: "application/octet-stream"});// change resultByte to bytes

      var link=document.createElement('a');
      link.href=window.URL.createObjectURL(blob);
      link.download="myFileName.xlsx";
      link.click(); */
       
       // window.open(response.data, '_blank')
      // var sampleArr = base64ToArrayBuffer(response.data);
       //Download(response.data,"application/octet-stream")
      // const arrayBuffer = base64ToArrayBufferModified(response.data);
        //createAndDownloadBlobFile(arrayBuffer, 'testName');
       // saveByteArray("Sample Report.xlsx", sampleArr);
       
    //   } else {
    //     console.log('view report not available')
    //   }
    //   console.log('Actions Admin Dashboard -> Response', response)
      
    // }) 


  


export const emailDashboardData = (downloadDataObj) => (dispatch) => {
  console.log('download dashboard data action call')
  const userDetail = encryptStorage.getItem('session-user')
  documentsAPI
    .post(`document/admin/dashboard/${userDetail.user_id}/email`, {
      companyName: downloadDataObj.companyName,
      from:downloadDataObj.from,
      to:downloadDataObj.to,
      offset: downloadDataObj.page*10,
      limit: 10,
      page:downloadDataObj.page +1
    })
    .then((response) => {
      console.log('Response value', response);
      console.log('Response value', response.data);
      if (response.status == 200) {
        console.log('Response value 200', response);
        dispatch({
          type: EMAIL_DASHBOARD_DATA,
          payload: response.status
        })
      } else {
        console.log('view report not available')
      }
      console.log('Actions Admin Dashboard -> Response', response)
      
    })
    .catch((error) => {
      var errResponseDispatched = 'Error case';
     console.log('Error message:',error);
     dispatch({
      type: EMAIL_DASHBOARD_DATA,
      payload: errResponseDispatched
    })
    })
}

export const searchCompany=(reqObj)=>(dispatch) => {
  

  usersAPI.post(`user/license/company/search`, reqObj)
//  usersAPI.get(`user/license/company?search=${reqObj.data}&offset=${reqObj.offset}&page_count=${reqObj.page}&customer_type=${reqObj.customer_type}&status=${reqObj.status}&sort_field=${reqObj.sort_field}&sort_order=${reqObj.sort_order}`)
  
//usersAPI.get(`user/license/company?offset=${reqObj.offset}&page_count=${reqObj.page}`)
  .then((response) => {
    
    console.log('Response from searchCompany:',response);
    if(response.status == 200){
    }
    dispatch({
      type: SEARCH_COMPANY_DATA,
      payload: response
    })
  })
  .catch((error) => {
    var errResponseDispatched = 'Error case';
   console.log('Error message:',error);
  
  })
}

export const getLicensingModuleDetails =(reqObj) => (dispatch) => {
  usersAPI.post(`user/license/company/search`, reqObj)
  //usersAPI.get(`user/license/company?offset=${reqObj.offset}&page_count=${reqObj.page}`)
  .then((response) => {
    
    console.log('Response from Licensing api:',response);
    if(response.status == 200){
    }
    dispatch({
      type: LICENSE_DASHBOARD_DATA,
      payload: response
    })
  })
  .catch((error) => {
    var errResponseDispatched = 'Error case';
   console.log('Error message:',error);
  
  })
  
 
}

export const createCompany = (newReq) => (dispatch) => {
  
  usersAPI.post(`user/license/company`, newReq).then((response) => {
    
    dispatch({
      type: CREATE_COMPANY,
      payload: response.data,
    })
  })
}

export const getCountries = () => (dispatch) => {
  
  usersAPI.get(`user/license/company/countries`).then((response) => {
    
    dispatch({
      type: GET_COUNTRIES,
      payload: response.data,
    })
  })
}

export const updateCompany = (newReq) => (dispatch) => {
  
  usersAPI.put(`user/license/company/`, newReq).then((response) => {
    
    dispatch({
      type: UPDATE_COMPANY,
      payload: response.data,
    })
  })
}

export const getSubscriptionDefaults = () => (dispatch) => {
  usersAPI.get(`user/license/company/defaults`).then((response) => {
    dispatch( { type: GET_SUBSCRIPTION_DEFAULTS, payload: response.data })
  })
}

export const clearCompanyStatus = () => (dispatch) => {
  console.log('clear Company Status')
    dispatch({
      type: CLEAR_COMPANY_STATUS,
      payload: null
    })
  }


export const setEmailDataFlag = (downloadDataObj) => (dispatch) => {
  console.log('download dashboard data action call')
    dispatch({
      type: EMAIL_DASHBOARD_DATA,
      payload: null
    })
  }
  export const resetDashboardData = () => (dispatch) => {
    console.log('download dashboard data action call')
      dispatch({
        type: SET_DASHBOARD_DATA,
        payload: {dashboardResponseList:[]}
      })
    }
  
export function base64ToArrayBufferModified(binaryString: string) {
  //const binaryString = window.atob(base64); // Comment this if not using base64
  const bytes = new Uint8Array(binaryString.length);
  return bytes.map((byte, i) => binaryString.charCodeAt(i));
}

function Download(arrayBuffer, type) {
  var blob = new Blob([arrayBuffer], { type: type });
  var url = URL.createObjectURL(blob);
  window.open(url);
}

function base64ToArrayBuffer(base64) {
  var binaryString = window.atob(base64);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);
  for (var i = 0; i < binaryLen; i++) {
     var ascii = binaryString.charCodeAt(i);
     bytes[i] = ascii;
  }
  return bytes;
}

function saveByteArray(reportName, byte) {
  var blob = new Blob([byte], {type: "application/octet-stream"});
  var link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  var fileName = reportName;
  link.download = fileName;
  link.click();
};

function downloadExcelFromByteStream(byteStream, fileName) {
  const textDecoder = new TextDecoder('utf-8');
  const utf8Data = textDecoder.decode(new Uint8Array(byteStream));
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet([{}]);
  XLSX.utils.sheet_add_aoa(worksheet, XLSX.utils.sheet_to_json(XLSX.utils.table_to_sheet(document.createElement('table'))));  
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  const excelData = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
  const arrayBuffer = new ArrayBuffer(excelData.length);
  const view = new Uint8Array(arrayBuffer);
  for (let i = 0; i < excelData.length; i++) {
    view[i] = excelData.charCodeAt(i) & 0xFF;
  }
  const blob = new Blob([arrayBuffer], { type: 'application/vnd.ms-excel' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}



export function createAndDownloadBlobFile(body, filename, extension = 'xls') {
  const blob = new Blob([body]);
  const fileName = `${filename}.${extension}`;
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, fileName);
  } else {
    const link = document.createElement('a');
    // Browsers that support HTML5 download attribute
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}



